// TailLink v2 Design System — Theme tokens
// Source: handoff bundle (taillink-upgrade)

export const SERIF = "'Fraunces', 'Instrument Serif', Georgia, serif";
export const UI = "'Plus Jakarta Sans', 'IBM Plex Sans Thai', -apple-system, system-ui, sans-serif";
export const MONO = "'JetBrains Mono', 'Space Grotesk', ui-monospace, monospace";

export const TL_THEMES = {
  coral: {
    bg: '#FFF5EA', surface: '#FFFFFF', text: '#2D1B4E', muted: 'rgba(45,27,78,0.68)',
    primary: '#FF7A45', primaryInk: '#fff', accent: '#FFD93D',
    safe: '#10B981', alert: '#EF4444', warn: '#F59E0B', info: '#3B82F6',
    cardBorder: 'rgba(45,27,78,0.18)', shadow: '0 14px 34px -10px rgba(45,27,78,0.22)',
    sunsetA: '#FFD93D', sunsetB: '#FF7A45', sunsetC: '#E85D75',
    navBg: 'rgba(255,255,255,0.94)', navBorder: 'rgba(45,27,78,0.24)',
    navText: '#2D1B4E', navMuted: 'rgba(45,27,78,0.72)', navActiveBg: 'rgba(255,122,69,0.14)',
    fieldBg: '#FFFDF9', elevatedBorder: 'rgba(45,27,78,0.28)',
    skeleton: 'rgba(45,27,78,0.09)',
  },
  dark: {
    bg: '#120B20', surface: '#24163D', text: '#FFF8F1', muted: 'rgba(255,248,241,0.76)',
    primary: '#FF7A45', primaryInk: '#fff', accent: '#FFD93D',
    safe: '#10B981', alert: '#EF4444', warn: '#F59E0B', info: '#60A5FA',
    cardBorder: 'rgba(255,248,241,0.20)', shadow: '0 18px 44px -14px rgba(0,0,0,0.68)',
    sunsetA: '#FFD93D', sunsetB: '#FF7A45', sunsetC: '#B794F6',
    navBg: 'rgba(18,11,32,0.94)', navBorder: 'rgba(255,248,241,0.26)',
    navText: '#FFF8F1', navMuted: 'rgba(255,248,241,0.78)', navActiveBg: 'rgba(255,122,69,0.20)',
    fieldBg: '#1A102D', elevatedBorder: 'rgba(255,248,241,0.34)',
    skeleton: 'rgba(255,248,241,0.10)',
  },
};

export function buildTheme(name = 'coral', customPrimary) {
  if (name === 'custom') {
    return { ...TL_THEMES.coral, primary: customPrimary || TL_THEMES.coral.primary };
  }
  return TL_THEMES[name] || TL_THEMES.coral;
}
